<template>
  <div>
    <b-modal id="schedule-visit-modal" ref="scheduleVisitModal" hide-footer hide-header :no-close-on-esc="noCloseOnOutsideClick" :no-close-on-backdrop="noCloseOnOutsideClick">
      <div class="modal-layout">
        <div class="modal-title">
          <b
            ><p class="fs-16 pl-15">Schedule the Visit<br /></p
          ></b>
        </div>
        <div>
          <p class="what-type-vist-text">
            What type of visit would you like to schedule?
          </p>
        </div>
        <div class="visit-layout">
          <div v-for="(visits, index) in scheduleVisitType" :key="index" @click="selectVisit(visits, index)">
            <div
              class="typeOfScheduleBox"
              :class="{
                visitInActiveBgColor: visits.selected === true,
                visitActiveBgColor: visits.selected === false
              }"
            >
              <div class="ml-10">
                <img class="video-call-logo" :src="visits.logoUrl" />
                <span
                  class="ml-13"
                  :class="{
                    visitActiveText: visits.selected === true,
                    visitText: visits.selected === false
                  }"
                  >{{ visits.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-schdeule-layout">
          <span class="cancelText mr-20" @click="closeScreen()" :disabled="cancelNextDisable">Cancel</span>
          <button class="btn btn-primary next-btn-alignment" :class="{ nextBtnDisableClass: cancelNextDisable === true }" @click="next()" :disabled="cancelNextDisable">
            <span class="fs-13">Next</span>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="schedule-visit-Date-modal" ref="scheduleVisitDateModal" hide-footer hide-header :no-close-on-esc="noCloseOnOutsideClick" :no-close-on-backdrop="noCloseOnOutsideClick" class="modal_body">
      <div>
        <div class="modal-title">
          <b
            ><p class="fs-16 pl-25">Schedule {{ scheduledVisitName }}<br /></p
          ></b>
        </div>
        <div>
          <p v-if="showDate" class="schedule-visit-text pl-10 pr-10 fs-18">
            What day would you like to schedule?
          </p>
          <p v-if="!showDate" class="schedule-visit-text pl-10 pr-10 fs-18">
            What time would you like to schedule?
          </p>
        </div>
        <div class="date-primary-layout">
          <div class="date-secondary-layout">
            <template v-if="showDate">
              <div
                v-for="(data, dIndex) in dateValues"
                :class="{
                  'date-main-layout': data.extendWindowSlot === false,
                  'date-main-extended-window-layout': data.extendWindowSlot === true
                }"
                :key="dIndex"
              >
                <label class="btn btn-default" @click="dateSelect(dIndex)">
                  <input type="radio" class="scheduler-radio" v-model="data.selected" :name="'Scheduler' + dIndex" />
                  <span class="ml-15 req-opt-lbl">{{ toSiteTeamLocalDate(data.dateValue) }}</span>
                </label>
              </div>
            </template>
            <template v-if="!showDate">
              <div v-for="(data, dIndex) in timeValues" class="date-main-layout" :key="dIndex">
                <label class="btn btn-default" @click="timeSelect(dIndex)">
                  <input type="radio" class="scheduler-radio" v-model="data.selected" :name="'SchedulerTime' + dIndex" />
                  <span class="ml-15 req-opt-lbl">{{ toSiteTeamLocalTime(data.slotStartTime) }}</span>
                </label>
              </div>
            </template>
          </div>
        </div>
        <div>
          <span v-if="showDate && dateValues.length != dateTotalValues.length" class="show-more-dates-text" @click="increaseDates()">Show more dates</span>
          <span v-if="!showDate && timeValues.length != timeTotalValues.length" class="show-more-dates-text" @click="increaseTime()">Show more time</span>
        </div>
        <div class="date-bottom-layout bottom-layout-primaryAlignment">
          <div class="date-lower-bottom-layout">
            <span class="cancelText mr-20" @click="closeScreen()">Cancel</span>
            <button v-if="showDate" class="btn btn-primary next-btn-alignment" :class="{ nextBtnDisableClass: nextDateDisabled === true }" :disabled="nextDateDisabled" @click="goToNextTime(showDate)">
              <span class="fs-13">Next</span>
            </button>
            <button v-if="!showDate" class="btn btn-primary next-btn-alignment" :class="{ nextBtnDisableClass: nextTimeDisabled === true }" :disabled="nextTimeDisabled" @click="goToNextTime(showDate)">
              <span class="fs-13">Next</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="schedule-visit-VideoCall-Complete-modal" ref="scheduleVisitCompleteModal" hide-footer hide-header :no-close-on-esc="noCloseOnOutsideClick" :no-close-on-backdrop="noCloseOnOutsideClick" class="modal_body">
      <div>
        <div class="modal-title">
          <b
            ><p class="fs-16 pl-24">Schedule {{ scheduledVisitName }}<br /></p
          ></b>
        </div>
        <div>
          <p class="schedule-visit-text fs-18 pl-10" v-if="scheduledVisitName === 'Video Call' || scheduledVisitName === 'Office Visit'">
            Confirm the day and time below.
          </p>
          <p class="schedule-visit-text fs-18 pl-10" v-if="scheduledVisitName === 'Home Visit'">
            Enter the participant's address and confirm the time for your visit.
          </p>
          <p class="schedule-visit-text fs-18 pl-10" v-if="scheduledVisitName === 'Phone Call'">
            Enter the participant's phone number and confirm the time for your visit.
          </p>
        </div>
        <div class="confirm-date-main-layout">
          <div>
            <span class="confirm-date-text">{{ selectedDateFormatString }}</span>
          </div>
          <div>
            <span class="confirm-date-text">at {{ selectedTimeFormatString }}</span>
          </div>
          <div>
            <span class="change-visit-text" @click="goToEditVisitPage()" v-if="scheduledVisitName === 'Video Call'">Change visit time</span>
            <span class="change-visit-text" @click="goToEditVisitPage()" v-if="scheduledVisitName === 'Home Visit' || scheduledVisitName === 'Office Visit' || scheduledVisitName === 'Phone Call'">Change visit day and time</span>
          </div>
        </div>
        <div class="home-visit-dataLayout" v-if="scheduledVisitName === 'Home Visit'">
          <fieldset class="addressFieldset">
            <legend>
              Address
            </legend>
            <input type="text" class="addressCenterTxtBox center" v-model="homeVisitDetails.address" />
          </fieldset>
          <div class="home-visit-city-layout">
            <fieldset class="cityFieldset mt-13 mr-25">
              <legend>
                City
              </legend>
              <input type="text" class="cityTxtBox cityCenter" v-model="homeVisitDetails.city" />
            </fieldset>
            <fieldset class="stateFieldset mt-13">
              <legend>
                State/Province
              </legend>
              <input type="text" class="stateTxtBox stateCenter" v-model="homeVisitDetails.state" />
            </fieldset>
          </div>
          <div class="home-visit-city-zip-layout">
            <fieldset class="zipPostalCodeFieldset mt-13 ml-70">
              <legend>
                <span class="fs-12">Zip/Postal Code</span>
              </legend>
              <input type="text" class="zipPostalTxtBox zipPostalCenter pl-10" v-model="homeVisitDetails.postalCode" />
            </fieldset>
            <fieldset class="countryFieldset mt-13 ml-65">
              <legend>
                Country
              </legend>
              <input type="text" class="countryTxtBox countryCenter pl-10" v-model="homeVisitDetails.country" />
            </fieldset>
          </div>
        </div>
        <div class="phone-call-dataLayout" v-if="scheduledVisitName === 'Phone Call'">
          <div class="phoneCall-complete-mainLayout">
            <div>
              <vue-tel-input class="p-0" @onInput="onInputUserPhone" v-model="phoneNoData.phoneNumber" ref="userPhoneNumber"></vue-tel-input>
            </div>
          </div>
          <div>
            <span v-if="phoneNoData.phoneNumber && phoneNoData.phoneNumber.length && !validMobile" class="error-style">Phone number is invalid</span>
          </div>
        </div>
        <div class="confirm-date-main-layout" v-if="scheduledVisitName === 'Office Visit'">
          <div>
            <span class="confirm-date-text">{{ siteDetailsInfo.name }}</span>
          </div>
          <div>
            <span class="officeVisit-siteAddress-text">
              <span v-if="siteDetailsInfo.city && siteDetailsInfo.city != ''">{{ siteDetailsInfo.city }},</span>
              <span v-if="siteDetailsInfo.state && siteDetailsInfo.state != ''"> {{ siteDetailsInfo.state }},</span>
              <span v-if="siteDetailsInfo.country && siteDetailsInfo.country != ''"> {{ siteDetailsInfo.country }}</span>
            </span>
          </div>
        </div>
        <div
          class="form-group"
          :class="{
            'home-visits-Notes-Layout': scheduledVisitName === 'Home Visit',
            'video-call-Notes-Layout': scheduledVisitName === 'Video Call',
            'office-visits-Notes-Layout': scheduledVisitName === 'Office Visit'
          }"
        >
          <label for="exampleFormControlTextarea1"></label>
          <textarea v-if="scheduledVisitName === 'Phone Call'" v-model="siteTeamNotes" type="text" class="form-control" placeholder="Enter notes for the participant in the participant's language. Adding notes is optional." id="exampleFormControlTextarea1" rows="6"></textarea>
          <textarea
            v-if="scheduledVisitName !== 'Phone Call'"
            v-model="siteTeamNotes"
            type="text"
            :class="{
              homeVisitTextAreaStyle: scheduledVisitName === 'Home Visit',
              notesTextAreaWidth: scheduledVisitName != 'Home Visit'
            }"
            class="form-control"
            placeholder="Enter notes for the participant in the participant's language. Adding notes is optional."
            id="exampleFormControlTextarea1"
            rows="6"
          ></textarea>
          <div class="character-limit-layout">
            <span class="character-limit-text">160 character limit</span>
          </div>
        </div>
        <button class="btn btn-primary cancelVisitBtn" v-if="modalType === 'postScheduleVisit'" @click="cancelVisit()">
          <span class="fs-13" @click="cancelVisit()">Cancel Visit</span>
        </button>
        <div class="date-bottom-layout">
          <div
            :class="{
              'date-lower-complete-bottom-layout': scheduledVisitName != 'Home Visit',
              'date-lower-complete-bottom-layout-homeVisit': scheduledVisitName === 'Home Visit'
            }"
          >
            <span class="cancelText mr-20" @click="closeScreen()">Cancel</span>
            <button class="btn btn-primary" @click="completeVisit()">
              <span class="fs-13">Complete</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="cancel-schedule-visit-modal" ref="cancelScheduleVisitModal" hide-footer hide-header :no-close-on-esc="noCloseOnOutsideClick" :no-close-on-backdrop="noCloseOnOutsideClick" class="modal_body">
      <div class="modal-layout">
        <div class="modal-title">
          <b
            ><p class="fs-16 pl-15">{{ scheduledVisitName }} - {{ visitConfiguredDetails.telehealthVisitDTO.activityName }}<br /></p
          ></b>
        </div>
        <div>
          <p class="schedule-visit-text fs-18">
            You are about to cancel this visit.
          </p>
        </div>
        <div class="confirm-date-main-layout">
          <div>
            <span class="confirm-date-text">{{ selectedDateFormatString }}</span>
          </div>
          <div>
            <span class="confirm-date-text">at {{ selectedTimeFormatString }}</span>
          </div>
        </div>
        <div class="cancel-content-header">
          <p class="schedule-visit-text fs-18">
            Please be advised the participant will be notified of the
          </p>
          <p class="schedule-visit-text cancel-second-contentText fs-18">
            cancellation. Would you like to continue?
          </p>
        </div>
        <div class="form-group cancelTextNotesLayout">
          <label for="exampleFormControlTextarea1"></label>
          <textarea type="text" class="form-control" placeholder="Enter a reason for cancellation in the participant’s language. Adding a reason is optional." v-model="cancelReason" id="exampleFormControlTextareaCancel1" rows="6"></textarea>
          <div class="character-limit-layout">
            <span class="character-limit-text">160 character limit</span>
          </div>
        </div>
        <div class="date-bottom-layout-cancel">
          <div class="date-lower-complete-bottom-layout">
            <span class="cancelText mr-20" @click="closeScreen()">Cancel</span>
            <button class="btn btn-primary" @click="cancelActionVisit()">
              <span class="fs-13">Complete</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import countriesDataLists from "../../../data/countries-data.json";

export default {
  name: "ScheduleVisitSiteTeam",
  components: {},
  props: {
    modalType: {
      type: String
    },
    mapVisitsData: {
      type: Object
    },
    participantInfo: {
      type: Object
    },
    studyId: {
      type: String
    },
    piDetails: {
      type: Object
    },
    siteTeamSelectedTaskDetails: {
      type: Object
    },
    appointmentDetails: {
      type: Object
    },
    visitConfiguredDetails: {
      type: Object
    },
    siteDetailsInfo: {
      type: Object
    }
  },
  data() {
    return {
      noCloseOnOutsideClick: true,
      scheduleVisitType: [],
      cancelNextDisable: true,
      dateValues: [],
      timeValues: [],
      showDate: true,
      nextDateDisabled: true,
      nextTimeDisabled: true,
      scheduledVisitName: "",
      getCountriesLists: [],
      selectedCountryIsoName: "",
      siteTeamNotes: "",
      dateTotalValues: [],
      timeTotalValues: [],
      dateCounter: 1,
      timeCounter: 1,
      homeVisitDetails: {
        address: "",
        city: "",
        state: "",
        postalCode: "",
        country: ""
      },
      phoneNo: "",
      cancelReason: "",
      selectedDateFormatString: "",
      selectedTimeFormatString: "",
      extendedWindowDatesSlotFalse: [],
      extendedWindowDatesSlotTrue: [],
      validMobile: false,
      phoneNoData: {
        countryCode: "",
        smsCountryIsoName: "",
        phoneNumber: ""
      },
      getOnlyPhoneNo: ""
    };
  },
  methods: {
    selectVisit(data, primaryIndex) {
      const visitsData = [...this.scheduleVisitType];
      _.forEach(visitsData, (value, index) => {
        if (primaryIndex === index) {
          this.scheduleVisitType[index].selected = true;
          switch (value.name) {
            case "Video Call":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/video-call-active-icon.svg`;
              this.scheduledVisitName = "Video Call";
              break;
            case "Office Visit":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/OfficeVisit-Site-Active.png`;
              this.scheduledVisitName = "Office Visit";
              break;
            case "Home Visit":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/HomeVisit-Site-Active.png`;
              this.scheduledVisitName = "Home Visit";
              break;
            case "Phone Call":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/PhoneCall-Site-Active.png`;
              this.scheduledVisitName = "Phone Call";
              break;
          }
        } else {
          this.scheduleVisitType[index].selected = false;
          switch (value.name) {
            case "Video Call":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/video-call-icon.svg`;
              break;
            case "Office Visit":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/office-visit-icon.svg`;
              break;
            case "Home Visit":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/home-visit-icon.svg`;
              break;
            case "Phone Call":
              this.scheduleVisitType[index].logoUrl = `static/img/telehealth/phone-call-icon.svg`;
              break;
          }
        }
      });
      this.cancelNextDisable = false;
      if (this.modalType === "postScheduleVisit") {
        let getVisitType = this.appointmentDetails.visitType;
        switch (getVisitType) {
          case "Homevisit":
            getVisitType = "Home Visit";
            break;
          case "Telehealth":
            getVisitType = "Video Call";
            break;
          case "In-person":
            getVisitType = "Office Visit";
            break;
          case "Phonecall":
            getVisitType = "Phone Call";
            break;
        }
        if (this.scheduledVisitName === getVisitType) {
          this.siteTeamNotes = this.appointmentDetails.visitNote;
        } else {
          this.siteTeamNotes = "";
        }
      }
      this.$refs.scheduleVisitCompleteModal.hide();
    },
    closeScreen() {
      this.$emit("cancelEvent");
      this.$refs.scheduleVisitModal.hide();
    },
    next() {
      this.$refs.scheduleVisitModal.hide();
      this.showDate = true;
      this.$refs.scheduleVisitDateModal.show();
    },
    dateSelect(Dateindex) {
      const date_Values = [...this.dateValues];
      _.forEach(date_Values, (value, index) => {
        if (Dateindex === index) {
          date_Values[index].selected = true;
        } else {
          date_Values[index].selected = false;
        }
      });
      this.nextDateDisabled = false;
      const getSelectedData = date_Values.filter(dateObj => {
        return dateObj.selected === null || dateObj.selected === true;
      });
      const getFilteredTimeValues = this.mapVisitsData.timeTotalValues.filter(timeObj => {
        return timeObj.currentDate === getSelectedData[0].dateValue;
      });
      this.timeTotalValues = getFilteredTimeValues;
      _.forEach(this.timeTotalValues, (value, index) => {
        this.timeTotalValues[index].selected = false;
      });
      this.timeValues = _.take(this.timeTotalValues, 5 * this.timeCounter);
      this.nextTimeDisabled = true;
      this.$forceUpdate();
      this.checkDateValidation();
    },
    timeSelect(Timeindex) {
      const time_Values = [...this.timeValues];
      _.forEach(time_Values, (value, index) => {
        if (Timeindex === index) {
          time_Values[index].selected = true;
        } else {
          time_Values[index].selected = false;
        }
      });
      const getSelectedDate = this.dateValues.filter(dateObj => {
        return dateObj.selected === null || dateObj.selected === true;
      });
      const getSelectedTime = time_Values.filter(dateObj => {
        return dateObj.selected === null || dateObj.selected === true;
      });
      this.finalDateFormatString(getSelectedDate[0].dateValue);
      this.finalTimeFormatString(getSelectedTime[0].slotStartTime);
      this.nextTimeDisabled = false;
      this.checkTimeValidation();
    },
    toSiteTeamLocalDate(record) {
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const siteTeamLocal = momentTimeZone(record)
        .tz(abbr)
        .format("DD MMM YYYY");
      return moment(record).format("dddd") + ",  " + siteTeamLocal;
    },
    toSiteTeamLocalTime(record) {
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const siteTeamLocal = momentTimeZone(record)
        .tz(abbr)
        .format("hh:mm A z");
      return siteTeamLocal;
    },
    goToNextTime(showDate) {
      if (showDate === true) {
        if (this.modalType === "postScheduleVisit") {
          const date_Values = [...this.dateValues];
          let filteredVisitTypeChangeDateValues = [];
          const getDateSelectedIndex = date_Values.findIndex(dateObj => {
            return dateObj.selected === null || dateObj.selected === true;
          });
          const getSelectedDataString = date_Values[getDateSelectedIndex];
          let getFilteredTimeValues = this.mapVisitsData.timeTotalValues.filter(timeObj => {
            return new Date(timeObj.currentDate).toLocaleDateString() === new Date(getSelectedDataString.dateValue).toLocaleDateString();
          });
          if (this.returnVisitTypeBackEnd(this.scheduledVisitName) != this.appointmentDetails.visitType) {
            const getDates = [...getFilteredTimeValues];
            _.forEach(getDates, (value, index) => {
              getDates[index].selected = false;
            });
            _.forEach(getDates, (value, index) => {
              if (this.toSiteTeamLocalDateTime(value.dateValue) === this.toSiteTeamLocalDateTime(this.appointmentDetails.startTime)) {
                getDates[index].selected = null;
              }
            });
            filteredVisitTypeChangeDateValues = getDates.filter(data => {
              return data.selected == false;
            });
            getFilteredTimeValues = filteredVisitTypeChangeDateValues;
            this.nextTimeDisabled = true;
          } else if (this.returnVisitTypeBackEnd(this.scheduledVisitName) === this.appointmentDetails.visitType) {
            const getDateTimeValues = [...getFilteredTimeValues];
            _.forEach(getDateTimeValues, (value, index) => {
              if (this.toSiteTeamLocalDateTime(value.dateValue) === this.toSiteTeamLocalDateTime(this.appointmentDetails.startTime)) {
                getDateTimeValues[index].selected = null;
              } else {
                getDateTimeValues[index].selected = false;
              }
            });
          }
          getFilteredTimeValues = _.uniqBy(getFilteredTimeValues, "slotStartTime");
          this.timeTotalValues = _.orderBy(getFilteredTimeValues, ["dateValue"], ["asc"]);
          const selectCountCheck = this.timeTotalValues.filter(data => data.selected === null || data.selected === true);
          if (selectCountCheck.length === 0) {
            this.nextTimeDisabled = true;
          } else {
            this.nextTimeDisabled = false;
          }
          this.timeValues = _.take(this.timeTotalValues, 5 * this.timeCounter);
        }
        const getDateSelectedIndex = this.dateValues.findIndex(dateObj => {
          return dateObj.selected === null || dateObj.selected === true;
        });
        if (getDateSelectedIndex > -1) {
          if (this.dateValues[getDateSelectedIndex].extendWindowSlot) {
            this.$toastr.warning("This date falls outside of your scheduling window.");
          }
        }
        this.showDate = false;
        this.$forceUpdate();
      } else {
        const getSelectedDate = this.dateValues.filter(dateObj => {
          return dateObj.selected === null || dateObj.selected === true;
        });
        const getSelectedTime = this.timeTotalValues.filter(dateObj => {
          return dateObj.selected === null || dateObj.selected === true;
        });
        this.finalDateFormatString(getSelectedDate[0].dateValue);
        this.finalTimeFormatString(getSelectedTime[0].slotStartTime);
        this.$refs.scheduleVisitCompleteModal.show();
        this.$refs.scheduleVisitDateModal.hide();
        setTimeout(() => {
          this.phoneNoData.phoneNumber = `${this.getOnlyPhoneNo.replace("+", "")}`;
          setTimeout(() => {
            this.phoneNoData.phoneNumber = `${this.phoneNoData.countryCode}${this.getOnlyPhoneNo.replace("+", "")}`;
          }, 200);
        }, 500);
      }
    },
    completeVisit() {
      const selectedVisitTime = _.filter(this.timeValues, function(timeValue) {
        return timeValue.selected == null || timeValue.selected == true;
      });
      if (this.siteTeamNotes != null && this.siteTeamNotes.length > 160) {
        this.$toastr.error("Notes must not exceed the maximum length of 160 characters.");
      } else {
        if (this.checkValidations()) {
          let formatVisitType = "";
          switch (this.scheduledVisitName) {
            case "Video Call":
              formatVisitType = "Telehealth";
              break;
            case "Office Visit":
              formatVisitType = "In-person";
              break;
            case "Home Visit":
              formatVisitType = "Homevisit";
              break;
            case "Phone Call":
              formatVisitType = "Phonecall";
              break;
          }
          let piAvailabilityId = "";
          let piAvailabilitySlot = "";
          if (selectedVisitTime.length == 0) {
            const getSelectedVisitTimeIndex = _.findIndex(this.timeTotalValues, function(timeValue) {
              return timeValue.selected == null || timeValue.selected == true;
            });
            piAvailabilityId = this.timeTotalValues[getSelectedVisitTimeIndex].availabilityId;
            piAvailabilitySlot = this.timeTotalValues[getSelectedVisitTimeIndex].appointmentSlotId;
          } else {
            piAvailabilityId = selectedVisitTime[0].availabilityId;
            piAvailabilitySlot = selectedVisitTime[0].appointmentSlotId;
          }
          const visitScheduleObject = {
            piId: this.piDetails.id,
            participantId: this.participantInfo.id,
            studyId: this.studyId,
            siteId: this.participantInfo.siteId,
            visitId: this.siteTeamSelectedTaskDetails.taskId,
            piAvailabilityId: piAvailabilityId,
            piAvailabilitySlot: piAvailabilitySlot,
            taskInstanceUUID: this.siteTeamSelectedTaskDetails.taskInstanceId,
            studyVersionId: "",
            visitType: formatVisitType,
            appointementTimeOffset: this.getLocalOffset(),
            visitNote: this.siteTeamNotes
          };
          if (formatVisitType === "Homevisit" || formatVisitType === "Phonecall") {
            this.phoneNo = this.phoneNo.replace(this.phoneNoData.countryCode, "");
            switch (formatVisitType) {
              case "Phonecall":
                visitScheduleObject.participantAppointmentContact = {
                  countryCode: this.phoneNoData.countryCode,
                  smsCountryIsoName: this.selectedCountryIsoName,
                  phoneNumber: this.phoneNo.toString()
                };
                break;
              case "Homevisit":
                visitScheduleObject.participantAppointmentContact = {
                  address: this.homeVisitDetails.address,
                  city: this.homeVisitDetails.city,
                  state: this.homeVisitDetails.state,
                  country: this.homeVisitDetails.country,
                  zipcode: this.homeVisitDetails.postalCode,
                  countryCode: this.phoneNoData.countryCode
                };
                break;
            }
          }
          this.$emit("scheduledVisitData", visitScheduleObject);
          this.$refs.scheduleVisitCompleteModal.hide();
        }
      }
    },
    editVisit() {
      this.$refs.scheduleVisitCompleteModal.show();
    },
    cancelVisit() {
      this.$refs.scheduleVisitCompleteModal.hide();
      this.$refs.cancelScheduleVisitModal.show();
    },
    increaseDates() {
      this.dateValues = this.dateTotalValues;
    },
    increaseTime() {
      this.timeCounter = this.timeCounter + 1;
      this.timeValues = _.take(this.timeTotalValues, 5 * this.timeCounter);
    },
    goToEditVisitPage() {
      if (this.mapVisitsData.scheduleVisitType.length === 1) {
        this.showDate = true;
        this.$refs.scheduleVisitCompleteModal.hide();
        this.$refs.scheduleVisitDateModal.show();
      } else {
        this.cancelNextDisable = false;
        this.$refs.scheduleVisitCompleteModal.hide();
        const getSelectedIndex = this.scheduleVisitType.findIndex(data => data.selected === true);
        this.selectVisit(this.scheduleVisitType, getSelectedIndex);
        this.$refs.scheduleVisitModal.show();
      }
    },
    cancelActionVisit() {
      this.$swal({
        title: "You are about to cancel this visit. Please be advised the participant will be notified of the cancellation and its reason. Would you like to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (this.cancelReason.length > 160) {
            this.$toastr.error("Notes must not exceed the maximum length of 160 characters.");
          } else {
            this.$emit("cancelVisitEvent", { cancelReason: this.cancelReason });
            this.$refs.cancelScheduleVisitModal.hide();
          }
        }
      });
    },
    finalDateFormatString(selectedDate) {
      const record = selectedDate;
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const weekDay = momentTimeZone(record)
        .tz(abbr)
        .format("dddd");
      const getdate = momentTimeZone(record)
        .tz(abbr)
        .format("DD MMM YYYY");
      this.selectedDateFormatString = `${weekDay}, ${getdate}`;
    },
    finalTimeFormatString(selectedTime) {
      const record = selectedTime;
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const getTime = momentTimeZone(record)
        .tz(abbr)
        .format("hh:mm A z");
      this.selectedTimeFormatString = getTime;
    },
    getLocalOffset() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    },
    checkValidations() {
      let validFlag = true;
      if (this.scheduledVisitName === "Home Visit") {
        if (this.homeVisitDetails.address === "") {
          validFlag = false;
          this.$toastr.error("Address cannot be empty.");
        } else if (this.homeVisitDetails.city === "") {
          validFlag = false;
          this.$toastr.error("City cannot be empty.");
        } else if (this.homeVisitDetails.state === "") {
          validFlag = false;
          this.$toastr.error("State cannot be empty.");
        } else if (this.homeVisitDetails.postalCode === "") {
          validFlag = false;
          this.$toastr.error("Zip/Postal Code cannot be empty.");
        } else if (this.homeVisitDetails.country === "") {
          validFlag = false;
          this.$toastr.error("Country cannot be empty.");
        }
      } else if (this.scheduledVisitName === "Phone Call") {
        this.getOnlyPhoneNo = this.getOnlyPhoneNo.replace("+", "");
        if (this.getOnlyPhoneNo === "") {
          validFlag = false;
          this.$toastr.error("Phone No cannot be empty.");
        } else if (this.selectedCountryIsoName === "") {
          validFlag = false;
          this.$toastr.error("Country Code cannot be empty.");
        } else if (this.getOnlyPhoneNo) {
          const checkIsNaN = /^\d+$/.test(this.getOnlyPhoneNo);
          if (!checkIsNaN) {
            validFlag = false;
            this.$toastr.error("Invalid phone number format. Please enter numbers only.");
          }
          if (!this.validMobile && checkIsNaN) {
            validFlag = false;
            this.$toastr.error("Invalid phone number format.");
          }
        }
      }
      return validFlag;
    },
    returnVisitTypeBackEnd(type) {
      let formattedType = "";
      switch (type) {
        case "Home Visit":
          formattedType = "Homevisit";
          break;
        case "Video Call":
          formattedType = "Telehealth";
          break;
        case "Office Visit":
          formattedType = "In-person";
          break;
        case "Phone Call":
          formattedType = "Phonecall";
          break;
      }
      return formattedType;
    },
    toSiteTeamLocalDateTime(record) {
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const siteTeamLocal = momentTimeZone(record)
        .tz(abbr)
        .format("DD-MM-YYYY hh:mm A z");
      return siteTeamLocal;
    },
    checkDateValidation() {
      setTimeout(() => {
        const getDateSelectedcheckIndex = this.dateValues.findIndex(dateObj => {
          return dateObj.selected === null;
        });
        if (getDateSelectedcheckIndex === -1) {
          this.scheduledVisitName === "Office Visit" ? this.$toastr.error(`Please select a day you would like to schedule an ${this.scheduledVisitName.toLowerCase()} for.`) : this.$toastr.error(`Please select a day you would like to schedule a ${this.scheduledVisitName.toLowerCase()} for.`);
          this.nextDateDisabled = true;
        } else {
          this.nextDateDisabled = false;
        }
      }, 500);
    },
    checkTimeValidation() {
      setTimeout(() => {
        const getTimeSelectedcheckIndex = this.timeValues.findIndex(timeObj => {
          return timeObj.selected === null;
        });
        if (getTimeSelectedcheckIndex === -1) {
          this.scheduledVisitName === "Office Visit" ? this.$toastr.error(`Please select a time you would like to schedule an ${this.scheduledVisitName.toLowerCase()} for.`) : this.$toastr.error(`Please select a time you would like to schedule a ${this.scheduledVisitName.toLowerCase()} for.`);
          this.nextTimeDisabled = true;
        } else {
          this.nextTimeDisabled = false;
        }
      }, 500);
    },
    onInputUserPhone({ number, isValid, country }) {
      this.validMobile = isValid;
      const numberCopy = number;
      let phoneNoCopy = "";
      if (typeof numberCopy === "object") {
        phoneNoCopy = numberCopy.input.toString().replace(/\s/g, "");
      } else {
        phoneNoCopy = numberCopy.toString().replace(/\s/g, "");
      }
      this.getOnlyPhoneNo = phoneNoCopy.toString().replace(country.dialCode, "");
      this.phoneNo = phoneNoCopy.toString().replace(country.dialCode, "");
      this.phoneNoData.phoneNumber = phoneNoCopy.toString().replace(/\s/g, "");
      this.phoneNoData.smsCountryIsoName = country.iso2.toLowerCase();
      this.phoneNoData.countryCode = "+" + country.dialCode;
      this.selectedCountryIsoName = this.phoneNoData.smsCountryIsoName;
      if (phoneNoCopy.includes("+")) {
        this.phoneNo = this.phoneNoData.phoneNumber.replace(country.dialCode, "").replace(/[^a-zA-Z0-9 ]/g, "");
      } else {
        this.phoneNo = this.phoneNoData.phoneNumber.replace(/[^a-zA-Z0-9 ]/g, "");
      }
    }
  },
  created() {
    this.scheduleVisitType = this.mapVisitsData.scheduleVisitType;
    this.dateTotalValues = this.mapVisitsData.dateTotalValues;
    this.timeTotalValues = this.mapVisitsData.timeTotalValues;
    let getCountryCode = "";
    switch (this.modalType) {
      case "preScheduleVisit":
        this.homeVisitDetails.address = this.participantInfo.address ? this.participantInfo.address : "";
        this.homeVisitDetails.city = this.participantInfo.city ? this.participantInfo.city : "";
        this.homeVisitDetails.state = this.participantInfo.state ? this.participantInfo.state : "";
        this.homeVisitDetails.postalCode = this.participantInfo.zipcode ? this.participantInfo.zipcode : "";
        this.homeVisitDetails.country = this.participantInfo.country ? this.participantInfo.country : "";
        this.selectedCountryIsoName = this.participantInfo.smsCountryIsoName ? this.participantInfo.smsCountryIsoName.toLowerCase() : "";
        this.phoneNo = this.participantInfo.phoneNumber ? this.participantInfo.phoneNumber : "";
        this.getOnlyPhoneNo = this.phoneNo;
        if (this.selectedCountryIsoName) {
          getCountryCode = countriesDataLists.filter(data => data[1].toLowerCase() === this.selectedCountryIsoName.toLowerCase());
          if (this.phoneNo.includes("+" + getCountryCode[0][2])) {
            this.phoneNo = this.phoneNo.replace("+" + getCountryCode[0][2], "").trim();
          }
          this.phoneNo = this.phoneNo.replace(/ /g, "");
          this.phoneNo = this.phoneNo.replace(/[^a-zA-Z0-9 ]/g, "");
          this.phoneNoData.phoneNumber = `+${getCountryCode[0][2]}${this.phoneNo}`;
          if (this.phoneNoData.phoneNumber) {
            this.phoneNoData.countryCode = "+" + getCountryCode[0][2];
            this.phoneNoData.smsCountryIsoName = getCountryCode[0][1].toLowerCase();
            this.validMobile = true;
          }
        }
        break;
      case "postScheduleVisit":
        this.homeVisitDetails.address = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.address ? this.appointmentDetails.participantAppointmentContact.address : this.participantInfo && this.participantInfo.address ? this.participantInfo.address : "";
        this.homeVisitDetails.city = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.city ? this.appointmentDetails.participantAppointmentContact.city : this.participantInfo && this.participantInfo.city ? this.participantInfo.city : "";
        this.homeVisitDetails.state = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.state ? this.appointmentDetails.participantAppointmentContact.state : this.participantInfo && this.participantInfo.state ? this.participantInfo.state : "";
        this.homeVisitDetails.postalCode = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.zipcode ? this.appointmentDetails.participantAppointmentContact.zipcode : this.participantInfo && this.participantInfo.zipcode ? this.participantInfo.zipcode : "";
        this.homeVisitDetails.country = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.country ? this.appointmentDetails.participantAppointmentContact.country : this.participantInfo && this.participantInfo.country ? this.participantInfo.country : "";
        this.selectedCountryIsoName = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.smsCountryIsoName ? this.appointmentDetails.participantAppointmentContact.smsCountryIsoName.toLowerCase() : this.participantInfo && this.participantInfo.smsCountryIsoName ? this.participantInfo.smsCountryIsoName.toLowerCase() : "";
        this.phoneNo = this.appointmentDetails.participantAppointmentContact && this.appointmentDetails.participantAppointmentContact.phoneNumber ? this.appointmentDetails.participantAppointmentContact.phoneNumber : this.participantInfo && this.participantInfo.phoneNumber ? this.participantInfo.phoneNumber : "";
        this.getOnlyPhoneNo = this.phoneNo;
        if (this.selectedCountryIsoName) {
          getCountryCode = countriesDataLists.filter(data => data[1].toLowerCase() === this.selectedCountryIsoName.toLowerCase());
          if (this.phoneNo.includes("+" + getCountryCode[0][2])) {
            this.phoneNo = this.phoneNo.replace("+" + getCountryCode[0][2], "");
          }
          this.phoneNo = this.phoneNo.replace(/ /g, "");
          this.phoneNo = this.phoneNo.replace(/[^a-zA-Z0-9 ]/g, "");
          this.phoneNoData.phoneNumber = `+${getCountryCode[0][2]}${this.phoneNo}`;
          if (this.phoneNoData.phoneNumber) {
            this.phoneNoData.countryCode = "+" + getCountryCode[0][2];
            this.phoneNoData.smsCountryIsoName = getCountryCode[0][1].toLowerCase();
            this.phoneNo = this.phoneNoData.phoneNumber;
            this.validMobile = true;
          }
        }
        this.finalDateFormatString(this.appointmentDetails.startTime);
        this.finalTimeFormatString(this.appointmentDetails.startTime);
        this.siteTeamNotes = this.appointmentDetails.visitNote;
        let getVisitType = this.appointmentDetails.visitType;
        switch (getVisitType) {
          case "Homevisit":
            getVisitType = "Home Visit";
            break;
          case "Telehealth":
            getVisitType = "Video Call";
            break;
          case "In-person":
            getVisitType = "Office Visit";
            break;
          case "Phonecall":
            getVisitType = "Phone Call";
            break;
        }
        this.scheduledVisitName = getVisitType;
        this.nextDateDisabled = false;
        this.nextTimeDisabled = false;
        break;
    }
  },
  mounted() {
    _.forEach(this.dateTotalValues, dateValue => {
      const getIndex = this.timeTotalValues.findIndex(data => {
        return new Date(data.dateValue).toLocaleDateString() === new Date(dateValue.dateValue).toLocaleDateString();
      });
      if (getIndex === -1) {
        dateValue.extendWindowSlot = false;
      } else {
        dateValue.extendWindowSlot = this.timeTotalValues[getIndex].extendWindowSlot;
      }
    });
    this.extendedWindowDatesSlotFalse = this.dateTotalValues.filter(dt => dt.extendWindowSlot === false);
    this.extendedWindowDatesSlotTrue = this.dateTotalValues.filter(dt => dt.extendWindowSlot === true);

    if (this.modalType === "preScheduleVisit") {
      this.$refs.scheduleVisitModal.show();
      if (this.visitConfiguredDetails.telehealthVisitDTO.extendAvailability) {
        if (this.extendedWindowDatesSlotFalse.length > 0) {
          this.dateValues = this.extendedWindowDatesSlotFalse;
        } else {
          this.dateValues = this.dateTotalValues;
        }
      } else {
        this.dateValues = this.dateTotalValues;
      }
      setTimeout(() => {
        this.$refs.userPhoneNumber.phone = this.phoneNoData.phoneNumber;
      }, 1500);
    } else {
      this.$refs.scheduleVisitCompleteModal.show();
      setTimeout(() => {
        this.$refs.userPhoneNumber.phone = this.phoneNoData.phoneNumber;
      }, 1500);
      this.dateValues = this.dateTotalValues;
    }
    this.getCountriesLists = [];
    _.forEach(countriesDataLists, value => {
      const obj = {
        dial_code: "+" + value[2],
        code: value[1].toLowerCase(),
        name: value[0]
      };
      this.getCountriesLists.push(obj);
    });
    this.timeValues = _.take(this.timeTotalValues, 5 * this.timeCounter);
    this.phoneNoData.phoneNumber = `${this.phoneNoData.countryCode}${this.getOnlyPhoneNo}`;
  }
};
</script>
<style scoped lang="scss">
.modal-title {
  clear: both;
  padding-top: 0.4rem;
  position: relative;
  right: 0.9rem;
}
.typeOfScheduleBox {
  width: 17rem;
  height: 3.5rem;
  box-shadow: 0px 1px 4px 0px #888888;
  border: 1px 1px 1px 1px solid;
  border-radius: 7px;
  align-items: center;
  display: flex;
  margin-bottom: 1.5rem;
  cursor: pointer;
}
.what-type-vist-text {
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  padding-right: 4rem;
  position: relative;
  bottom: 0.8rem;
}
.visit-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.visitText {
  color: #4a4a4a;
  font-weight: bold;
  font-size: 15px;
}
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 0.9rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.cancelText {
  color: #666669;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.visitActiveBgColor {
  background-color: #ffffff;
}
.visitInActiveBgColor {
  background-color: #4c8ce4;
}
.visitActiveText {
  color: #ffffff;
  font-weight: normal;
  font-size: 15px;
  opacity: 0.9;
}
.schedule-visit-text {
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  padding-right: 4rem;
  position: relative;
  bottom: 0.7rem;
}
.date-primary-layout {
  background-color: #f5f8fa;
  height: 18rem;
  position: relative;
  right: 1rem;
  width: 31.2rem;
  overflow-y: scroll;
}
.date-secondary-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 1.1rem;
  flex-direction: column;
  padding-bottom: 0.8rem;
}
.date-main-layout {
  background-color: #ffffff;
  width: 29rem;
  height: 3rem;
  margin-bottom: 0.5rem;
  border: 0.5px solid #d3dfe4;
  left: 0.2rem;
  position: relative;
}
.show-more-dates-text {
  color: #4c8ce4;
  font-weight: bold;
  position: relative;
  top: 1.1rem;
  cursor: pointer;
}
.date-bottom-layout {
  float: right;
  padding-bottom: 4rem;
  position: relative;
  bottom: 1.8rem;
}
.date-lower-bottom-layout {
  position: relative;
  top: 4rem;
}
.scheduler-radio {
  transform: scale(1.4);
}
.btn-default {
  position: relative;
  top: 0.6rem;
  left: 0.1rem;
}
.req-opt-lbl {
  color: #6f6f6f;
  font-weight: bold;
  opacity: 0.7;
}
.date-lower-complete-bottom-layout {
  position: relative;
  top: 4rem;
  left: 6rem;
}
.date-lower-complete-bottom-layout-homeVisit {
  position: relative;
  top: 4rem;
  left: 8rem;
}
.confirm-date-main-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.confirm-date-text {
  color: #4a4a4a;
  font-weight: bold;
  font-size: 21px;
}
.change-visit-text {
  color: #4c8ce4;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
}
.character-limit-layout {
  float: right;
  position: relative;
  bottom: 1.8rem;
  right: 0.9rem;
}
.character-limit-text {
  color: #b0bac9;
  font-size: 12px;
}
.home-visits-Notes-Layout {
  margin-left: 2rem;
  width: 25rem;
}
.video-call-Notes-Layout {
  padding-left: 1rem;
  padding-right: 1rem;
}
.home-visit-dataLayout {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 1rem;
}
fieldset {
  border: 1px solid #ddd !important;
  margin: 0;
  padding: 10px;
  position: relative;
  border-radius: 4px;
}
.addressFieldset {
  padding-right: 21rem;
  position: relative;
  border-radius: 4px;
  padding-left: 10px !important;
  width: 27rem;
  height: 3.3rem;
  padding-bottom: 1.6rem;
}
legend {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  font-weight: bold;
  opacity: 0.7;
}

.addressCenterTxtBox {
  border: none;
  background-color: none;
  outline: 0;
  font-size: 16px;
  width: 22rem;
  height: 18px;
}

.center {
  height: 40px;
  width: 382px;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 1rem;
  right: 1rem;
}
.cityTxtBox {
  border: none;
  background-color: none;
  outline: 0;
  font-size: 16px;
  width: 22rem;
  height: 18px;
}

.cityFieldset {
  width: 14rem;
  padding-right: 9rem;
  padding-left: 1rem;
  padding-top: 1.6rem;
}
.cityCenter {
  height: 40px;
  width: 177px;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 1rem;
  right: 1rem;
}
.stateFieldset {
  width: 11.2rem;
  padding-right: 4.8rem;
  padding-left: 1rem;
}
.stateTxtBox {
  border: none;
  background-color: none;
  outline: 0;
  font-size: 16px;
  width: 22rem;
  height: 18px;
}
.stateCenter {
  height: 40px;
  width: 150px;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 1rem;
  right: 1rem;
}

.zipPostalCodeFieldset {
  width: 11rem;
  padding-right: 4rem;
  padding-left: 1rem;
  padding-top: 1.6rem;
}
.zipPostalTxtBox {
  border: none;
  background-color: none;
  outline: 0;
  font-size: 16px;
  width: 22rem;
  height: 18px;
}
.zipPostalCenter {
  height: 40px;
  width: 169px;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 1rem;
  right: 0.5rem;
}
.countryFieldset {
  padding-right: 10.7rem;
  padding-left: 1rem;
  position: relative;
  right: 2.8rem;
  width: 236px;
}
.countryTxtBox {
  border: none;
  background-color: none;
  outline: 0;
  font-size: 16px;
  width: 22rem;
  height: 18px;
}
.countryCenter {
  height: 40px;
  width: 234px;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 1rem;
  right: 1rem;
}
.homeVisitTextAreaStyle {
  width: 28rem;
  position: relative;
  right: 1.3rem;
}
.notesTextAreaWidth {
  width: 25rem;
}

.phone-call-dataLayout {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 1rem;
}

.countryCodeFieldset {
  width: 6rem;
  padding-top: 0rem;
  height: 3.8rem;
}

.phoneNoFieldset {
  width: 21.2rem;
  padding-right: 14.1rem;
  padding-left: 1rem;
  position: relative;
  right: 3rem;
  padding-top: 1.6rem;
}

.phoneNoTxtBox {
  border: none;
  background-color: none;
  outline: 0;
  font-size: 16px;
  width: 22rem;
  height: 18px;
}
.phoneNoCenter {
  height: 40px;
  width: 234px;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 1rem;
  right: 1rem;
}

select {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none;
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down-dark.png);
  padding: 0.5em;
  padding-right: 1.5em;
  opacity: 1;
  margin-left: 1rem;
  border: none;
  position: relative;
  bottom: 0.5rem;
  right: 1.2rem;
  font-weight: bold;
  color: #4a4a4a;
  padding-left: 1rem;
}

.blue-banner {
  background-color: #eaf0f4;
  height: 65px;
  padding: 9px;
  .title {
    color: #b0bac9;
  }
  .description {
    color: #4a4a4a;
  }
}
.cancelVisitBtn {
  position: relative;
  top: 2rem;
  background-color: #fff;
  color: #4c8ce4;
  border-color: #4c8ce4;
  float: left;
}
.date-bottom-layout-cancel {
  float: right;
  position: relative;
  bottom: 5rem;
}
.cancel-content-header {
  position: relative;
  top: 1.5rem;
  width: 36rem;
}
.cancel-second-contentText {
  position: relative;
  bottom: 1.8rem;
}
.cancelTextNotesLayout {
  position: relative;
  bottom: 1.5rem;
}
.modal-layout {
  padding-left: 1rem;
  padding-right: 0.8rem;
}
.next-btn-alignment {
  padding-left: 1.4rem;
  padding-right: 1.4rem;
}
.bottom-schdeule-layout {
  float: right;
  padding-bottom: 1rem;
}
.evaluateModalPhnoField {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
}
.evaluateAddressField {
  color: #4a4a4a;
  font-weight: bold;
}
.bottom-layout-primaryAlignment {
  position: relative;
  bottom: 1rem;
}
.home-visit-city-layout {
  display: flex;
  flex-direction: row;
  margin-top: 0.7rem;
}
.home-visit-city-zip-layout {
  display: flex;
  flex-direction: row;
  margin-top: 0.7rem;
  margin-right: 2rem;
}
.phoneCall-complete-mainLayout {
  display: flex;
  flex-direction: row;
  margin-top: 0.7rem;
  margin-right: -2rem;
  padding-left: 5.5rem;
}
.countryCode-FieldSetAlignment {
  position: relative;
  right: 1.5rem;
  margin-right: 2rem;
}
.phoneNoFieldsetAlignment {
  position: relative;
  right: 6rem;
}
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 5px;
  background-clip: content-box;
  border: 5px solid transparent;
}

::-webkit-scrollbar {
  width: 20px;
}
::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  background-clip: content-box;
  border-radius: 11px;
  border: 6px solid transparent;
}
.date-main-extended-window-layout {
  background-color: #d3dfe4;
  width: 29rem;
  height: 3rem;
  margin-bottom: 0.5rem;
  border: 0.5px solid #ffffff;
  left: 0.2rem;
  position: relative;
}
.nextBtnDisableClass {
  opacity: 0.4;
}
.officeVisit-siteAddress-text {
  color: #4a4a4a;
  font-size: 15px;
}
.office-visits-Notes-Layout {
  margin-left: 11px;
  width: 25rem;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
}
.vue-tel-input {
  border-radius: 3px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border: 1px solid #bbb;
  text-align: left;
  height: 3rem;
  width: 21rem;
  position: relative;
  right: 3rem;
}
</style>
